import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  SelectProps,
} from "@mui/material";

interface GKSelectProps {
  inputLabel?: any;
  helperText?: string;
  requiredField?: boolean;
  loading?: boolean;
  placeholder?: string;
}

const GKSelect = (props: GKSelectProps & SelectProps) => {
  const { inputLabel, requiredField, helperText, error, ...rest } = props;

  return (
    <FormControl fullWidth error={error} sx={{ mt: inputLabel ? 0.7 : 0 }}>
      <InputLabel
        required={requiredField}
        sx={{
          "& .MuiFormLabel-asterisk": {
            color: "red",
          },
        }}
      >
        {inputLabel}
      </InputLabel>
      <Select
        {...rest}
        sx={{
          ...props.sx,
          borderRadius: 2,
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: 2,
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginRight: 0,
          },
        }}
        label={inputLabel}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default GKSelect;
